import ClockoutController from './clockout.controller';

/** Validation Controller capabilities for validating invitations
 * @extends ClockoutController
 */
class ValidationController extends ClockoutController {
    /**
     * Initialize the validation controller with a token
     */
    async tokenInitialize() {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        
        if (token) {
            await this.validateInvitation(token);
        } else {
            this.navigateLogin();
        }
    }
    /**
     * Validate an invitation
     * @param {string} token - The token to validate
     * @returns {Promise<void>}
     */
    async validateInvitation(token) {
        try {
            this.setState({ invitationValidating: true });
            const response = await this.data.validateInvitation(token);
            
            if (response && response.accessGranted) {
                console.log(response);
                this.setState({ 
                    invitationValid: true, 
                    invitationData: response.user,
                    email: response.user.email,
                    companyName: response.fi.name,
                    invitationValidating: false 
                });
            } else {
                this.setState({ 
                    invitationValid: false, 
                    invitationValidating: false 
                });
            }
        } catch (error) {
            console.error('Error validating invitation:', error);
            this.setState({ 
                invitationValid: false, 
                invitationValidating: false 
            });
        }
    }
}

export default ValidationController;
